import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "fileInput", "fileName"]
  static values = {
    allowedTypes: { type: Array, default: ["application/pdf", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"] }
  }

  connect() {
    // Initialize file input display
    this.updateFileName()
  }

  updateFileName() {
    const file = this.fileInputTarget.files[0]
    if (file) {
      this.fileNameTarget.textContent = file.name
    } else {
      this.fileNameTarget.textContent = ""
    }
  }

  validateFile(event) {
    const file = event.target.files[0]
    if (file && !this.allowedTypesValue.includes(file.type)) {
      // Show error using DaisyUI toast
      const toast = document.createElement('div')
      toast.className = 'toast toast-top toast-end'
      toast.innerHTML = `
        <div class="alert alert-error">
          <span>${this.element.dataset.errorMessage}</span>
        </div>
      `
      document.body.appendChild(toast)
      setTimeout(() => toast.remove(), 3000)

      // Clear the file input
      event.target.value = ''
      this.updateFileName()
    } else {
      this.updateFileName()
    }
  }

  async submit(event) {
    event.preventDefault()

    // Get CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    const response = await fetch(this.formTarget.action, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'application/json'
      },
      body: new FormData(this.formTarget)
    })

    if (response.ok) {
      const data = await response.json()
      // Show success using DaisyUI toast
      const toast = document.createElement('div')
      toast.className = 'toast toast-top toast-end'
      toast.innerHTML = `
        <div class="alert alert-success">
          <span>${data.message}</span>
        </div>
      `
      document.body.appendChild(toast)
      
      // Redirect after a short delay
      setTimeout(() => {
        window.location.href = this.element.dataset.redirectUrl
      }, 1000)
    } else {
      const data = await response.json()
      // Show error using DaisyUI toast
      const toast = document.createElement('div')
      toast.className = 'toast toast-top toast-end'
      toast.innerHTML = `
        <div class="alert alert-error">
          <span>${data.error.join(', ')}</span>
        </div>
      `
      document.body.appendChild(toast)
      setTimeout(() => toast.remove(), 3000)
    }
  }
}
